import React from 'react';
import PropTypes from 'prop-types';
import AbcLogo from '../logos/AbcLogo';
import DisneyLogo from '../logos/DisneyLogo';
import FxLogo from '../logos/FxLogo';
import EspnLogo from '../logos/EspnLogo';
import MarvelLogo from '../logos/MarvelLogo';
import NatGeoLogo from "../logos/NatGeoLogo";
import PixarLogo from '../logos/PixarLogo';
import LucasLogo from '../logos/LucasLogo';
import WaltDisneyLogo from '../logos/WaltDisneyLogo';
import EspnPlusLogo from '../logos/EspnPlusLogo';
import DMCLogo from '../logos/DMCLogo';
import DVCLogo from '../logos/DVCLogo';
import CruiseLogo from '../logos/CruiseLogo';
import InstituteLogo from '../logos/InstituteLogo';
import GoldenLogo from '../logos/GoldenLogo';
import TULogo from '../logos/TULogo';
import FTELogo from '../logos/FTELogo';
import NonSVGLogo from '../logos/NonSVGLogo';
import DisneyPlusLogo from '../logos/DisneyPlusLogo';
import DisneyStoreLogo from '../logos/DisneyStoreLogo';
import FoxLogo from "../logos/FoxLogo";

import MenuIcon from './MenuIcon';
import CloseIcon from './CloseIcon';
import MobileAccountInfo from './MobileAccountInfo';
import MobileNav from './MobileNav';

import {connect} from 'react-redux';
import {constants} from '../../utils/constants';

import _ from 'lodash';
import LanguagePicker from '../userActions/LanguagePicker';

export let Header = ({ name, page, showMobileMenu, location, dispatch }) => {
  let mobileMenu = (
    <span className='mobileMenu'>
      {showMobileMenu ? <MenuIcon dispatch={dispatch}/> : <CloseIcon dispatch={dispatch}/>}
    </span>
  );

  // If the mobile menu has been clicked stop scrolling
  if (page === constants.managePageName && !showMobileMenu) {
    document.getElementById('scrollContainer').className += " stopScrolling";
  } else {
    document.getElementById('scrollContainer').className = "";
  }

  let logo = window.logo;
  switch (logo) {
    case 'dadtv':
    case 'default-abc':
    case 'dmi':
    case 'freeform':
    case 'abc-local-kabc':
    case 'abc-local-kgo':
    case 'abc-local-kfsn':
    case 'abc-local-ktrk':
    case 'abc-local-wabc':
    case 'abc-local-wls':
    case 'abc-local-wpvi':
    case 'abc-local-wtvd':
    case 'photopass':
    case 'aulani':
    case 'adventures':
    case 'natgeo':
    case 'fx':
    case 'nationalgeographic':
    case 'nationalgeographic-expeditions':
      var content = (<NonSVGLogo logo={logo} filetype={'png'}/>);
      break;

    case 'abc-news':
      var content = (<NonSVGLogo logo={logo} filetype={'jpg'}/>);
      break;

    case 'default-disney':
      var content = (<DisneyLogo isPrimary={true}/>);
      break;

    case 'espn-plus':
      var content = (<EspnPlusLogo isPrimary={true}/>);
      break;

    case 'default-espn':
      var content = (<EspnLogo isPrimary={true}/>);
      break;

    case 'dmc':
      var content = (<DMCLogo isPrimary={true}/>);
      break;

    case 'institute':
      var content = (<InstituteLogo isPrimary={true}/>);
      break;

    case 'golden':
      var content = (<GoldenLogo isPrimary={true}/>);
      break;

    case 'cruise':
      var content = (<CruiseLogo isPrimary={true}/>);
      break;

    case 'dvc':
      var content = (<DVCLogo isPrimary={true}/>);
      break;

    case 'tu':
      var content = (<TULogo isPrimary={true}/>);
      break;

    case 'fte':
      var content = (<FTELogo isPrimary={true}/>);
      break;

    case 'disney-plus':
      var content = (<DisneyPlusLogo isPrimary={true}/>);
      break;

    case 'disney-store':
      var content = (<DisneyStoreLogo isPrimary={true}/>);
      break;

    case 'marvel':
      var content = (<MarvelLogo isPrimary={true}/>);
      break;

    case 'fox':
      var content = (<FoxLogo isPrimary={true}/>);
      break;

    case 'disney-books':
      var content = (<NonSVGLogo logo={logo} filetype={'png'}/>);
      break;

    case 'default':
    default:
      var content = (
        <span>
          <DisneyLogo/>
          <PixarLogo/>
          <LucasLogo/>
          <MarvelLogo/>
          <WaltDisneyLogo visible={showMobileMenu || page !== constants.managePageName}/>
          <NatGeoLogo/>
          <AbcLogo/>
          <EspnLogo/>
          <FxLogo/>
        </span>
      );
      break;
  }

  // If the users name is not provided then they did not login to view their data
  // and therefor don't need the account or logout links
  var accountInfoClassNames = [];
  if (_.isEmpty(name)) {
    accountInfoClassNames.push('display-none');
  }

  var langPickerClassNames = [];
  if (page === constants.managePageName) {
    langPickerClassNames.push('display-none');
  }

  return (
    <span>
      <div className='headerContainer'>
        <span className={langPickerClassNames.join(' ')}>
          <LanguagePicker />
        </span>
        <div className='logosBarContainer'>
          {(page === constants.managePageName) ? mobileMenu : ''}
          <span id='headerLogos'>
            {content}
          </span>
        </div>
        <span className={accountInfoClassNames.join(' ')}>
          <MobileAccountInfo name={name} visible={!showMobileMenu && page === constants.managePageName}/>
        </span>
      </div>
      <MobileNav visible={!showMobileMenu && page === constants.managePageName} location={location}/>
    </span>
  );
};

Header.propTypes = {
  dispatch: PropTypes.func,
  store: PropTypes.object,
  showMobileMenu: PropTypes.bool,
  name: PropTypes.string,
  page: PropTypes.string,
  location: PropTypes.string
};

let ConnectedHeader = connect(state => state.header)(Header);
export default ConnectedHeader;



// WEBPACK FOOTER //
// ./client/src/components/header/Header.jsx